import React, {Component} from 'react'
import CBaseComponent from '@/components/CBaseComponent'
import store from "../../../../redux";
import './index.scss'
import {Button, Modal, Input, message,Checkbox} from "antd";
import {bindActionCreators, compose} from "redux";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {getInfo} from "../../../../servers/menuAPI";
import {refreshMenu} from "../../../../redux/common/action";
import CTable from '@/components/CTable'
import { tableData } from './data'
@CBaseComponent
class SystemScore extends Component{

  constructor(props) {
    super(props);
    this.onSelect = this.onSelect.bind(this);
    this.downloads = this.downloads.bind(this)
    this.handlePreview = this.handlePreview.bind(this)
  }


  state = {
    columns: tableData.tHead,
    dataSource: tableData.tBody,
    notes:''
  }

  onSelect(){
    const params = {
      annual:localStorage.getItem('year'),
      indid:'4.4',
      museumid:store.getState().libraryid,
    }
    getInfo(params).then(res=>{
      if(res.statecode === 0) {
        this.setState({
          dataSource:res.records[0].annexlist,
        })
      } else {
        message.error('查询失败');
      }
    })
  }

  async handlePreview(file){
    if (file.filepreviewurl !== '' && file.filepreviewurl !== null) {
      const type =file.filename.split('.')[file.filename.split('.').length - 1]
      if (type === 'png' || type === 'jpg' || type === 'jpeg' || type === 'gif' || type === 'bmp' ) {
        this.setState({
          previewImage: file.filepreviewurl,
          previewVisible: true,
        });
      } else {
        window.open(file.filepreviewurl, '_blank')
      }
    }
  }

  downloads(file){
    var timer = ''
    if (file.fileurl !== '' && file.fileurl !== null) {
      clearTimeout(timer)
      window.location.href = file.fileurl
    } else {
      timer = setTimeout(()=>{
        this.handlePreview(file)
      },1)
    }
  }

  componentWillUnmount() {
    // 在组件卸载时取消订阅
    if (this.unsubscribe) this.unsubscribe();
  }

   componentDidMount(){
    this.onSelect()
    let currentState = store.getState();
    this.unsubscribe = store.subscribe(() => {
      let previousState = currentState;
      currentState = store.getState();
      if (previousState.libraryid !== currentState.libraryid) {
        this.onSelect()
        this.props.refreshMenu(true)
      }
      if (previousState.year !== currentState.year) {
        this.onSelect()
        this.props.refreshMenu(true)
      }
    })
  }

  render(){
    return (
        <div className='detail-container' id="top">
          <div className="import">
          <CTable ref='historyRecordDeleteUserList' checked={false} loading={false} columns={this.state.columns} dataSource={this.state.dataSource}>
            <div
                slot='index'
                render={(text, record, index) => (
                    <div className='operate'>
                      {index+1}
                    </div>
                )} />
            <div
                slot='yl'
                render={(text, record, index) => (
                    <div className='operate'>
                      <span style={{color:'#1890ff',cursor:'pointer'}} onClick={()=>{this.handlePreview(record)}}>预览</span>
                    </div>
                )} />
            <div
                slot='download'
                render={(text, record, index) => (
                    <div className='operate'>
                      <span style={{color:'#1890ff',cursor:'pointer'}} onClick={()=>{this.downloads(record)}}>下载</span>
                    </div>
                )} />
          </CTable>
          </div>
        </div>
    )
  }
}
const mapStateToProps = (state) => {
  return {
    collapsed: state.collapsed,  // 侧边栏是否展开
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    refreshMenu: bindActionCreators(refreshMenu, dispatch),
  };
};

export default compose(withRouter, connect(mapStateToProps,mapDispatchToProps))(SystemScore);
